/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { sva } from "@panda/css";

export const newsCard = sva({
	slots: ["wrapper", "overlay", "image-box", "image", "meta"],
	base: {
		wrapper: {
			"&&": {
				display: "flex",
				gap: "eds.dimension.12",
				minHeight: "172px",
				mdDown: {
					minHeight: "153px",
				},
			},

			"&:hover": {
				"& .image": {
					transform: "scale(1.05)",
				},
			},
			"& .cosmos-rich-text.heading": {
				lineClamp: "2",
				overflow: "hidden",
				mdDown: {
					lineClamp: "1",
				},
				"& p": {
					margin: 0,
				},
			},
			"& .cosmos-rich-text.paragraph": {
				lineClamp: "2",
				overflow: "hidden",
			},
		},
		"image-box": {
			minWidth: "max-content",
			// width: "193px",
			aspectRatio: "16/9",
			width: "263px",
			minHeight: "148px",
			lgDown: {
				minWidth: "148px",
				aspectRatio: "1/1",
				width: "148px",
				minHeight: "148px",
			},
			mdDown: {
				minWidth: "max-content",
				aspectRatio: "16/9",
				width: "229px",
				minHeight: "129px",
			},
			smDown: {
				minWidth: "eds.dimension.96",
				aspectRatio: "unset!important",
				width: "eds.dimension.96",
				minHeight: "eds.dimension.128",
			},
		},
		image: {
			transition: "transform token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
			height: "100%",
			width: "100%",
			objectFit: "cover",
		},
	},
});
